// Main application class
class HiltonFitnessApp {
	constructor() {
		this.components = {};
		this.init();
	}

	init() {
		// Initialize Datadog RUM monitoring
		this.initDatadogRUM();

		// Initialize all components and store references
		this.components.mainNavigation = new MainNavigation();
		this.components.regionBrandSelection = new RegionBrandSelectionBlock();
		//this.components.supplierBlock = new SupplierBlockModal();
		this.components.twoColumnContentBlock = new TwoColumnContentBlock();
		this.components.footer = new Footer();
		this.components.slick = new Slick();

		// Initialize event tracking
		this.initEventTracking();



		/* nav */
		$(".navbar-icon .trigger").on("click", function () {
			$(".navbar-icon").toggleClass("active");
			$("body").toggleClass("oh");
			$(".navbar-menu nav").toggleClass("active");
		});
		$("nav a").on("click", function () {
			$(".navbar-menu nav, .navbar-icon").removeClass("active");
			$("body").removeClass("oh");
		});
		/* orphans and hyphens */

		$(".umb-block-list p").each(function () {
			var string = $(this).html();
			// Only replace space before last word if it's not inside or before an HTML tag
			string = string.replace(/ (\w+)(?![^<>]*>)(?!.*<\/[^>]+>$)$/m, "&nbsp;$1").replace(/-/g, "‑");
			$(this).html(string);
		});

		/* fix the region bar for brands */
		var fixme = $(".hero-brand-region");
		if (fixme.length) {
			var fixmeoffset = fixme.offset().top;
		}

		/* modals that work */
		$('a.learn-more-trigger').each(function () {
			$(this).on('click', function (e) {
				e.preventDefault();
				$('.modal').fadeOut()
				var modalData = $(this).data('trigger');
				console.log(modalData);
				$('.modal[data-modal="' + modalData + '"]').fadeIn();
			});
		});
		$('.close-modal, .modal').on('click', function () {
			$('.modal').fadeOut();
		});

		/* supplier FAQ */
		$('.supplier-tabs .tab-wrapper:eq(0) button').trigger('click');
		$('.supplier-tabs button').on('click', function () {
			$('.supplier-tabs .tab-wrapper').removeClass('active');
			$(this).parent().addClass('active');
		});

		$(window).on("scroll", function () {
			if (fixme.length) {
				if ($(window).scrollTop() >= fixmeoffset) {
					fixme.addClass("fixed");
				} else {
					fixme.removeClass("fixed");
				}
			}
		});
	}

	initDatadogRUM() {
		  (function(h,o,u,n,d) {
    h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}
    d=o.createElement(u);d.async=1;d.src=n
    n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)
		})(window,document,'script','https://www.datadoghq-browser-agent.com/us1/v6/datadog-rum.js','DD_RUM')
		window.DD_RUM.onReady(function() {
			window.DD_RUM.init({
			clientToken: 'puba0b2fcdd97accbd9356855d5e6b7a22e',
			applicationId: 'ce838fc1-0c00-4371-9732-34e599e9a785',
			// `site` refers to the Datadog site parameter of your organization
			// see https://docs.datadoghq.com/getting_started/site/
			site: 'datadoghq.com',
			service: 'hilton-fitness',
			env: 'staging',
			// Specify a version number to identify the deployed version of your application in Datadog
			// version: '1.0.0',
			sessionSampleRate: 100,
			sessionReplaySampleRate: 20,
			trackBfcacheViews: true,
			defaultPrivacyLevel: 'mask-user-input',
			});
		});

	}

	initEventTracking() {
		// Track all link clicks in SupplierBlock catalog links
		$(document).on("click", ".supplier-block-wrapper .catalog-links a", function (e) {
			const linkUrl = $(this).attr("href");
			const supplierName = $(this).closest(".accordion-item").find(".accordion-button").text().trim();
			const linkType = $(this).find(".bi-link-45deg").length > 0 ? "URL" : "File";

			// Send to gtag
			if (typeof gtag !== "undefined") {
				gtag("event", "catalog_link_click", {
					event_category: "Supplier",
					event_label: supplierName,
					link_url: linkUrl,
					link_type: linkType,
				});
			}

			// Send to Datadog RUM
			if (window.DD_RUM) {
				window.DD_RUM.addAction("catalog_link_click", {
					event_category: "Supplier",
					event_label: supplierName,
					link_url: linkUrl,
					link_type: linkType,
				});
			}
		});

		// Track Learn More link clicks in SupplierBlock
		$(document).on("click", ".supplier-block-wrapper .learn-more-trigger", function (e) {
			const supplierName = $(this).closest(".accordion-item").find(".accordion-button").text().trim();

			// Send to gtag
			if (typeof gtag !== "undefined") {
				gtag("event", "learn_more_click", {
					event_category: "Supplier",
					event_label: supplierName,
				});
			}

			// Send to Datadog RUM
			if (window.DD_RUM) {
				window.DD_RUM.addAction("learn_more_click", {
					event_category: "Supplier",
					event_label: supplierName,
				});
			}
		});

		// Track accordion opening in SupplierBlock
		$(document).on("shown.bs.collapse", ".supplier-block-wrapper .accordion-collapse", function (e) {
			const supplierName = $(this).closest(".accordion-item").find(".accordion-button").text().trim();

			// Send to gtag
			if (typeof gtag !== "undefined") {
				gtag("event", "accordion_open", {
					event_category: "Supplier",
					event_label: supplierName,
				});
			}

			// Send to Datadog RUM
			if (window.DD_RUM) {
				window.DD_RUM.addAction("accordion_open", {
					event_category: "Supplier",
					event_label: supplierName,
				});
			}
		});

		// Track email clicks in SupplierBlock contacts section
		$(document).on("click", '.supplier-block-wrapper .contacts a[href^="mailto:"]', function (e) {
			const emailAddress = $(this).attr("href").replace("mailto:", "");
			const supplierName = $(this).closest(".accordion-item").find(".accordion-button").text().trim();

			// Extract contact name from the contact info (first <strong> tag)
			const contactName = $(this).closest(".contact-info").find("strong").first().text().trim() || "Unknown";

			// Send to gtag
			if (typeof gtag !== "undefined") {
				gtag("event", "email_click", {
					event_category: "Supplier",
					event_label: supplierName,
					email_address: emailAddress,
					contact_name: contactName,
				});
			}

			// Send to Datadog RUM
			if (window.DD_RUM) {
				window.DD_RUM.addAction("email_click", {
					event_category: "Supplier",
					event_label: supplierName,
					email_address: emailAddress,
					contact_name: contactName,
				});
			}
		});
	}
}

// Initialize the app when DOM is ready
document.addEventListener("DOMContentLoaded", function () {
	window.HiltonFitnessApp = new HiltonFitnessApp();
});